<template>
  <div class="head">
    <div class="info row justify-between items-center">
      <div class="left row justify-start items-center">
        <div class="icon"><img :src="$config.IMG_URL+'/icon/time.png'" /></div>
        上班时间：周一 - 周五 8：30-17：15
      </div>
      <div class="right row justify-start items-center">
        <div class="row justify-between items-center">
          <div class="icon"><img :src="$config.IMG_URL+'/icon/mail.png'" /></div>
          zhongzhibaoxian1.zzbx@ciichr.com
        </div>
        <div class="row justify-between items-center">
          <div class="icon"><img :src="$config.IMG_URL+'/icon/phone.png'" /></div>
          400-820-3351
        </div>

      </div>
    </div>
    <div class="links row justify-between items-center">
      <router-link to="/"><img class="logo" :src="$config.IMG_URL+'/logo4.png'" /></router-link>
      <div class="right row justify-start items-center" >
        <router-link to="/"  v-bind:class={curent:isIndex}>首页</router-link>
        <a>
          关注我们
          <div class="qrbox">
            <img class="qr" :src="$config.IMG_URL+'/qrcode.png'" />
            <img class="txt" :src="$config.IMG_URL+'/qr_txt.png'" />
          </div>
        </a>
        <!--a target="_blank" href="http://tijian.51joying.com/index/web/list
">安心体检</a -->
        <a target="_blank" href="http://bx.51joying.com">安心保险</a>
        <router-link to="/pilu" v-bind:class={curent:isPilu}>信息披露</router-link>
        <!--router-link to="/lipei" v-bind:class={curent:isLipei}>安心理赔</router-link-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Head",
  props: ["type"],
  data() {
    return {
      isIndex: this.type == "index",
      isLipei: this.type == "lipei",
      isPilu: this.type == "pilu"
    };
  },
  created() {},
  methods: {}
};
</script>

<style scoped lang="less">
@import "../assets/common";

.head {
  position: absolute;
  width: 100%;
  z-index: 100;
  background: #ffffff;
  left: 0;
  top: 0;
  .icon {
    width: 18px;
    height: 18px;
    position: relative;
    margin-right: 7px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .info {
    color: #1d4491;
    width: 100%;
    height: 47px;
    max-width: 1640px;
    margin: 0 auto;
    font-size: 12px;
    border-bottom: 1px solid #e6e6e6;
    .right > div {
      margin-left: 28px;
    }
  }
  .links {
    height: 84px;
    background: #ffffff;
    max-width: 1640px;
    margin: 0 auto;
    .logo {
      width: 166px;
    }
    .curent {
      background: #cdd4e2;
      color: #ffffff;
      margin-left: 12px;
      height: 28px;
      border-radius: 14px;
      padding: 0 12px;
      line-height: 28px;
      position: relative;
      text-decoration: none;
    }
    .right {
      height: 28px;
      margin-top: 16px;
      font-size: 14px;
      a {
        color: #1d4491;
        margin-left: 12px;
        height: 28px;
        border-radius: 14px;
        padding: 0 12px;
        line-height: 28px;
        position: relative;
        text-decoration: none;

        .qrbox {
          position: absolute;
          font-size: 0;
          top: 36px;
          background: #ffffff;
          box-shadow: 0 0 10px #c7c8ca;
          left: 50%;
          transform: translate(-50%, 0);
          width: 200px;
          border-radius: 5px;
          display: none;
          &:after {
            border: 6px solid transparent;
            border-bottom: 6px solid #ffffff;
            width: 0;
            height: 0;
            top: -12px;
            left: 50%;
            margin-left: -3px;
            position: absolute;
            content: " ";
          }
          .qr {
            width: 160px;
            height: 160px;
            margin: 22px auto;
            display: block;
          }
          .txt {
            width: 100%;
            display: block;
          }
        }
        &:hover {
          cursor: pointer;
          background: #1d4491;
          color: #ffffff;
          .qrbox {
            display: block;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue